import { render } from "./CartBar.vue?vue&type=template&id=6b5c4312"
import script from "./CartBar.vue?vue&type=script&lang=js"
export * from "./CartBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__